import { register } from "./serviceWorkerRegistration";

/**
 * Register the production service worker (GitHub Pages + offline app shell).
 */
export function registerPwaServiceWorker() {
  register();
}
